module.exports = __webpack_public_path__ + "media/images/event/event-template-uz-64fdda095e14fbfc18f14c16002a6611.png";